<div id="container" class="container">
  <div [ngClass]="featureInfo.length > 1 ? 'header':'header-only-close'">
    <select name="select" id="selectorIframe" *ngIf="featureInfo.length > 1" (change)="selectNewIframe($event.target)">
      <option (click)="currentIndex = item.index" value="{{item.index}}" *ngFor="let item of this.featureInfo">
        {{item.title}}
      </option>
    </select>
    <div class="close" (click)="close()">
      <button class="close-button">
        ✕
      </button>
    </div>
  </div>
  <div class="info-popup-container">
    @if (featureInfo[currentIndex]) {
    <span class="title-style">{{featureInfo[currentIndex].title}}</span>
    <span class="padding-contianer text-align-center">{{featureInfo[currentIndex].abstract}}</span>
    <span class="padding-contianer text-align-center">Date Creation: {{featureInfo[currentIndex].dataCreation}}</span>
    @if (featureInfo[currentIndex].time_start) {
    <div class="period-container">
      <div class="period-graph-container">
        @if (featureInfo[currentIndex].time_start) {
        <span class="period-badge">{{featureInfo[currentIndex].time_start}}</span>
        } @else {
        <span class="period-badge">Not avaiable</span>
        }
        <span class="arrow-style"> → </span>
        @if (featureInfo[currentIndex].status == 'onGoing') {
        <span class="ongoing-badge">On Going</span>
        } @else {
        @if (featureInfo[currentIndex].time_end) {
        <span class="period-badge">{{featureInfo[currentIndex].time_end}}</span>
        } @else {
        <span class="period-badge">Not avaiable</span>
        }
        }
      </div>
    </div>
    }

    <div>

      @if (featureInfo[currentIndex].north && featureInfo[currentIndex].west && featureInfo[currentIndex].east &&
      featureInfo[currentIndex].south) {
      <div class="bbox-container">
        <div class="north-container text-align-center">{{featureInfo[currentIndex].north.toFixed(2)}}</div>
        <div class="west-container text-align-center">{{featureInfo[currentIndex].west.toFixed(2)}}</div>
        <div class="center-container"></div>
        <div class="east-container text-align-center">{{featureInfo[currentIndex].east.toFixed(2)}}</div>
        <div class="south-container text-align-center">{{featureInfo[currentIndex].south.toFixed(2)}}</div>
      </div>
      }

    </div>
    <div class="download-container">
      <span class="padding-contianer text-align-center">Climate Sphere:
        {{featureInfo[currentIndex].climateSphere}}</span>
      @if (featureInfo[currentIndex].geonetworkUrl || featureInfo[currentIndex].ri_link || featureInfo[currentIndex].doiUrl || featureInfo[currentIndex].erddapLink) {
      <span class="section-label">Other Links:</span>
      @if (featureInfo[currentIndex].ri_link) {
      <a target="_blank" class="link-style"
        [href]="featureInfo[currentIndex].ri_link">{{featureInfo[currentIndex].ri}}</a>
      }

      <div class="download-button-container">
        <a target="_blank" class="link-style" [href]="featureInfo[currentIndex].geonetworkUrl">Go to Geonetwork</a>
      </div>
      }

      @if (featureInfo[currentIndex].doiUrl) {
      <div class="download-button-container">
        <a target="_blank" class="link-style" [href]="featureInfo[currentIndex].doiUrl.split('?')[0]">Go to doi page</a>
      </div>
      }
      @if (featureInfo[currentIndex].erddapLink) {
      <div class="download-button-container">
        <a target="_blank" class="link-style"
          [href]="'https://s4polarin.eu/plot-page?externalconfigparser=polarin&externalconfigurl=' + featureInfo[currentIndex].erddapLink">Go to
          Plot Page</a>
      </div>
      }
      @if (featureInfo[currentIndex].platform_page) {
      <span class="section-label">Plot Page Links:</span>
      <div class="download-button-container">
        @for (item of featureInfo[currentIndex].platform_page | keyvalue; track $index) {
        <a target="_blank" class="link-style"
          [href]="'https://s4polarin.eu/plot-page?externalconfigparser=polarin&externalconfigurl=' + item.value">Plot
          Page {{$index + 1}}</a>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
